<template>
  <div id="reviewers-menu-volunteer">
    <div class="ipub-h1 line-h-40 relative mar-b-20">
      Volunteer Application
    </div>
    <div class="ipub-p2 fw-bd line-h-40 ipub-shadow tips mar-b-30 flex"
         v-if="params.handle">
      <ipub-icon :class="['mar-l-10', params.handle==='REFUSED'?'key-color':'',, params.handle==='ACCEPTED'?'success-color':'link-color']"
                 style="font-size: 16px"
                 type="iconDetails" />
      <font v-if="params.handle==='UNHANDLED'"
            class="mar-l-20">Your application is being processing.</font>
      <div v-else-if="params.handle==='REFUSED'"
           class="mar-l-20">
        <font>Sorry, Your application is </font>
        <font class="key-color">rejetced.</font>
        <div class="ipub-p2">
          <span class="fw-bd">Reject Reason: </span>{{params.reason}}
        </div>
        <!-- <a class="mar-l-20 link-color"
           @click="viewReason">View Reason</a> -->
        <a class="link-color"
           @click="reEdit">Re-edit Application</a>
      </div>
      <font class="mar-l-20"
            v-else-if="params.handle==='ACCEPTED'">Your application has been passed</font>
    </div>
    <div v-if="re_edit">
      <ipub-form ref="reviewers-menu-volunteer-form"
                 :model="params"
                 :rules="rules">
        <ipub-row :gutter="20">
          <ipub-col :span="3">
            <ipub-form-item prop="titleCode"
                            label="Title">
              <ipub-select v-model="params.titleCode"
                           :disabled="!!params.handle && !re_edit"
                           placeholder="Title">
                <ipub-select-option v-for="(value) in titleList"
                                    v-show="value.enabled"
                                    :key="value.id"
                                    :value="value.code">
                  {{ value.name }}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="3">
            <ipub-form-item prop="firstName"
                            label="First Name">
              <ipub-input placeholder="First Name"
                          :disabled="!!params.handle && !re_edit"
                          v-model.trim="params.firstName" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="3">
            <ipub-form-item prop="lastName"
                            label="Last Name">
              <ipub-input placeholder="Last Name"
                          :disabled="!!params.handle && !re_edit"
                          v-model.trim="params.lastName" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="3">
            <ipub-form-item prop="orcid"
                            label="ORCID">
              <ipub-input placeholder="ORCID"
                          :disabled="!!params.handle && !re_edit"
                          v-model.trim="params.orcid" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="countryCode"
                            label="Country / Territory">
              <ipub-select v-model="params.countryCode"
                           search
                           :clear="true"
                           :disabled="!!params.handle && !re_edit"
                           @search="countrySearch"
                           placeholder="Country / Territory">
                <ipub-select-option v-for="item in countryList"
                                    :value="item.code"
                                    :key="'countryList'+item.code">
                  {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="City"
                            label="City">
              <ipub-input placeholder="City"
                          :disabled="!!params.handle && !re_edit"
                          v-model.trim="params.city" />
            </ipub-form-item>
          </ipub-col>
          <!-- <ipub-col :span="4">
            <ipub-form-item prop="degreeCode"
                            label="Highest degree">
              <ipub-select v-model="params.degreeCode"
                           :disabled="!!params.handle && !re_edit"
                           placeholder="Highest degree">
                <ipub-select-option v-for="(value) in degreesList"
                                    v-show="value.enabled"
                                    :key="value.id"
                                    :value="value.code">
                  {{ value.name }}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col> -->
        </ipub-row>
        <ipub-form-item prop="affiliation"
                        label="Affiliations">
          <div slot="label"
               class="ipub-p2 fw-bd mar-b-10">
            Affiliations
            <span class="mar-l-20 link-color ipub-c-p"
                  @click="addMore('affiliations')">
              <ipub-icon type="iconAdd" />
              Add Affilications
            </span>
          </div>
          <div v-for="(item, index) in params.affiliations"
               class="mar-b-10"
               :key="'params.affiliations'+index">
            <ipub-input placeholder="Affiliations"
                        :suffixIcon="index===0?'':'iconClose'"
                        :disabled="!!params.handle && !re_edit"
                        @blur="getMore('affiliation')"
                        @iconClick="delMore('affiliations',index)"
                        v-model.trim="params.affiliations[index]" />
          </div>
          <!-- <ipub-button type="primary"
                     icon="iconAdd"
                     :disabled="!!params.handle && !re_edit"
                     @click="addMore('affiliations')"
                     style="width:240px"
                     plain>Add Affilications</ipub-button> -->
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="2">
            <ipub-form-item prop="hindex"
                            label="H-index">
              <ipub-input placeholder="H-index"
                          number
                          v-model="params.hindex" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="10">
            <ipub-form-item prop='hindexUrl'
                            label="H-Index URL">
              <ipub-input placeholder="H-Index URL"
                          v-model.trim="params.hindexUrl" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item label="Personal Homepage"
                            prop="website">
              <ipub-input placeholder="Personal Homepage"
                          :disabled="!!params.handle && !re_edit"
                          v-model.trim="params.website" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="rcv">
              <div class="ipub-p2 fw-bd mar-b-10 relative"
                   slot="label">
                CV <font class="key-color">*</font>
                <ipub-tooltip placement="right"
                              type="dark"
                              class="mar-l-10">
                  <div slot="title">PDF</div>
                  <ipub-icon type="iconInfo" />
                </ipub-tooltip>
                <!-- <div v-if="!params.handle || re_edit"
                   class="right-option">
                <ipub-upload class="ipub-c-p"
                             @change="(e)=>{handleUpload('rcv', e)}">
                  <a class="link-color">Upload</a>
                </ipub-upload>
              </div> -->
              </div>
              <div class="ipub-line-block ipub-border relative"
                   :style="!params.handle || re_edit?'':'background:#e9eef0'">
                <div style="width: calc(100% - 60px)">
                  <a @click="download(`${domain}/${params.rcv}`, params.rcvName)"
                     v-if="params.rcvName">{{params.rcvName}}</a>
                  <ipub-upload v-else-if="!params.handle || re_edit"
                               class="ipub-c-p"
                               style="width:100%"
                               @change="(e)=>{handleUpload('rcv', e)}">
                    <a class="line-color">Upload PDF File</a>
                  </ipub-upload>
                </div>
                <div class="right-option ipub-p4 flex"
                     v-if="params.rcvName && (!params.handle || re_edit)"
                     style="right: 10px">
                  <ipub-tooltip placement="bottom">
                    <div slot="title">
                      Replace
                    </div>
                    <ipub-upload v-if="true"
                                 class="line-h-40"
                                 @change="(e)=>{handleUpload('rcv', e)}">
                      <a>
                        <ipub-icon style="font-size:16px"
                                   type="iconReplace" />
                      </a>
                    </ipub-upload>
                  </ipub-tooltip>
                  <div style="padding: 0 4px"
                       class="line-color line-h-40">|</div>
                  <ipub-tooltip placement="bottom">
                    <div slot="title">
                      Delete
                    </div>
                    <a class="line-h-40"
                       @click="delFile('rcv')">
                      <ipub-icon style="font-size:16px"
                                 type="iconDelete" />
                    </a>
                  </ipub-tooltip>
                </div>
              </div>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>

        <ipub-form-item prop="reviewJournal"
                        label="Reviewed Journals">
          <div slot="label"
               class="ipub-p2 fw-bd mar-b-10">
            Reviewed Journals
            <span class="link-color mar-l-20 ipub-c-p"
                  @click="addMore('reviewJournals')">
              <ipub-icon type="iconAdd" />
              Add Reviewed Journal
            </span>
          </div>
          <div v-for="(item, index) in params.reviewJournals"
               class="mar-b-10"
               :key="'params.reviewJournals'+index">
            <ipub-input placeholder="Reviewed Journal"
                        suffixIcon="iconClose"
                        :disabled="!!params.handle && !re_edit"
                        @blur="getMore('reviewJournal')"
                        @iconClick="delMore('reviewJournals',index)"
                        v-model.trim="params.reviewJournals[index]" />
          </div>
          <!-- <ipub-button type="primary"
                     icon="iconAdd"
                     @click="addMore('reviewJournals')"
                     style="width:240px"
                     :disabled="!!params.handle && !re_edit"
                     plain>Add Reviewed Journal</ipub-button> -->
        </ipub-form-item>

        <ipub-form-item label="Keywords"
                        prop="keywords">
          <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                      tag
                      :disabled="!!params.handle && !re_edit"
                      v-model.trim="params.keywords" />
        </ipub-form-item>

        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="journalIdList"
                            label="Journal(s) Would Like to Review">
              <ipub-select v-model="params.journalIdList"
                           placeholder="Choose the journal(s) you would like to review"
                           mode="multiple"
                           :disabled="!!params.handle && !re_edit"
                           :options="journalList" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="frequencyCode"
                            label="Review Frequency">
              <ipub-select v-model="params.frequencyCode"
                           :disabled="!!params.handle && !re_edit"
                           placeholder="Select Review Frequency">
                <ipub-select-option v-for="(value) in reviewFrequencyList"
                                    v-show="value.enabled"
                                    :key="value.id"
                                    :value="value.code">
                  {{ value.name }}
                </ipub-select-option>
              </ipub-select>
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
      </ipub-form>
    </div>
    <div v-else
         class="ipub-p2">
      <div class="ipub-p1 mar-b-20"
           style="font-size:24px">{{title[params.titleCode]}}{{params.firstName}} {{params.lastName}}</div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">ORCID</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">{{params.orcid || '--'}}</span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">Country / Territory</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">{{country[params.countryCode] || '--'}}</span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">City</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">{{params.city || '--'}}</span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">H-index</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">{{params.hindex || '--'}}</span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">H-index URL</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">{{params.hindexUrl || '--'}}</span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">Affiliation(s)</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">
          <font v-if="params.affiliation">
            {{params.affiliation.includes(',')?params.affiliation.split(',').join('; '):params.affiliation}}
          </font>
          <font v-else>--</font>
        </span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">Personal Homepage</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">{{params.website || '--'}}</span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">CV</span>
        <span class="ipub-block__font link-color"
              style="width:calc(100% - 256px)">
          <ipub-label @click="download(`${domain}/${params.rcv}`, params.rcvName)"
                      class="ipub-p2 ipub-c-p"
                      type="link"
                      v-if="params.rcvName">{{params.rcvName}}
            <ipub-icon type="iconDownload1"
                       class="mar-l-10" />
          </ipub-label>
        </span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">Reviewed Journal(s)</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">
          <font v-if="params.reviewJournal">
            {{params.reviewJournal.includes(';')?params.reviewJournal.split(';').join('; '):params.reviewJournal}}
          </font>
          <font v-else>--</font>
        </span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">Research Keywords</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">
          <font v-if="params.keyword">
            {{params.keyword}}
          </font>
          <font v-else>--</font>
        </span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">Journal(s) Would Like to Review</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">{{(params.journalList && params.journalList.length>0 && params.journalList.map(item=>item.name).join('; ')) || '--'}}</span>
      </div>
      <div class="flex mar-b-10">
        <span class="ipub-block__span"
              style="width:256px">Review Frequency</span>
        <span class="ipub-block__font"
              style="width:calc(100% - 256px)">{{reviewFrequency[params.frequencyCode]}}</span>
      </div>
    </div>

    <div v-if="!params.handle || re_edit">
      <ipub-button plain
                   type="primary"
                   :style="{ minWidth: '150px' }"
                   @click="()=>{re_edit?re_edit=false:$router.back(-1)}">Cancel</ipub-button>
      <ipub-button type="primary"
                   :style="{ minWidth: '150px' }"
                   @click="submit">Save & Submit</ipub-button>
    </div>
    <Reject :isVisable="showReason"
            :inputData="params.reason"
            @confirm="reEdit"
            @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
